import classNames from 'classnames';

import { List } from '@mui/material';

import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(
  /* istanbul ignore next */ () => ({
    root: {
      padding: 0,
      margin: 0,
    },
  }),
  { classNamePrefix: 'DrawerMenu' }
);

function DrawerMenu({ children, className = '' }) {
  const classes = useStyles();

  return <List className={classNames(classes.root, className)}>{children}</List>;
}

export default DrawerMenu;
